import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
  detailsPage: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3),
  },
}));